import { inject } from '@angular/core'
import { provideAppInitializer } from '@angular/core'

import { catchError, firstValueFrom, of } from 'rxjs'

import { RuntimeConfigService } from '../config/runtime-config.service'
import { AUTH_SERVICE } from '../tokens/auth-service.token'
import { AUTH_STORE } from '../tokens/auth-store.token'

export const provideAuthInitializer = () => {
  return provideAppInitializer(async () => {
    const runtimeConfigService = inject(RuntimeConfigService)
    const authService = inject(AUTH_SERVICE)
    const authStore = inject(AUTH_STORE)

    // Wait for environment config to be loaded and applied.
    // APP_INITIALIZER runs all initializers concurrently, so the
    // environment initializer may not have finished loading /config.json
    // and applying apiUrl yet.
    await runtimeConfigService.configApplied

    // Try to restore from localStorage first (instant UI)
    const hasStoredSession = authStore.hasStoredSession()

    if (hasStoredSession) {
      authStore.restoreSessionFromStorage()
    }

    // Validate with backend (source of truth)
    const response = await firstValueFrom(
      authService.fetchCurrentUser().pipe(
        catchError(() => {
          // Cookies invalid/expired - clear everything
          authStore.clearAuth()
          return of(null)
        })
      )
    )

    if (response) {
      authStore.setUserFromMeResponse(response)
    }
  })
}
